import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../shared/shared.global-service';
import { selectFolderId, selectServices } from '../../../store/person/person.selectors';

@Injectable()
export class FolderNoteStore extends ComponentStoreV2Factory {
    folderId = toSignal(globalStore!.select(selectFolderId));
    relatedServices = globalStore!.selectSignal(selectServices);
}
